import loadable from '@loadable/component';
import { WithLazyHydration } from '../../WithLazyHydration';

const AnimalProfileLoadable = loadable(() => import('./AnimalProfile'), {
  resolveComponent: components => components.AnimalProfile
});

export const AnimalProfile = WithLazyHydration(AnimalProfileLoadable);
